import { Checkbox, Field, Label } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let AsLiquidLimitApparatusChecksSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <FieldSet>
        <Label>Liquid Limit Apparatus Checks</Label>
        <Field input={<Checkbox />} name="TotalPlayOfCupCheck" />
        <Field input={<Checkbox />} name="DepthOfWearCheck" />
        <Field input={<Checkbox />} name="MaxHeightOfCupCheck" />
      </FieldSet>
    </>
  );
};

AsLiquidLimitApparatusChecksSection = withInjectedProps(AsLiquidLimitApparatusChecksSection);

export { AsLiquidLimitApparatusChecksSection };
export default AsLiquidLimitApparatusChecksSection;
